import {defineComponent} from "vue";
import InputGroupForm from "@/components/InputGroupForm.vue";
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";
import http from "@/http-common";

export default defineComponent({
  components: {FormSelectVue, InputGroupForm},
  props: {
    statusList: [],
    peopleList: [],
    roleList: []
  },
  data() {
    return {
      modalEditOpened: false,
      isLoading: false,
      selectedItem: {
        id: null,
        status: null,
        username: null
      },
      changePswDiv: false,
      changeRoleDiv: false,
      showChangePassword: false,
      insertPass1: '',
      insertPass2: '',
      messPass: '',
      selectedRoles: [],
      validValue: {
        username: true,
        form: true
      },
    }
  },
  methods: {
    saveUser() {
      this.checkForm()
      if (this.validValue.form && this.validPass) {
        if (this.insertPass2.length > 0) {
          this.selectedItem.password = this.insertPass2;
        } else {
          this.selectedItem.password = null;
        }
      }
      if (this.validValue.form) {
        let vm = this
        http.post('/users/save', this.selectedItem)
        .then((res) => {
          vm.modalEditOpened = false
          if (res.data != null) {
            vm.$emit('saveItem', res.data, vm.selectedItem.id == null)
          }
        })
        .finally(() => vm.cleanItem())
      }
    },
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.username || this.selectedItem.username === '') {
        this.validValue.username = false;
        this.validValue.form = false;
      }
    },
    showEditForm(userId) {
      if (userId != null) {
        this.isLoading = true
        let vm = this
        http.get('/users/' + userId)
        .then((response) => {
          vm.selectedItem = response.data;

        })
        .catch((error) => console.log(error.message))
        .finally(() => this.isLoading = false);

      } else {
        this.cleanItem()
        this.selectedItem.peopleId = null
      }
      this.changePswDiv = this.selectedItem.id == null;
      if (this.selectedItem.roles == null) {
        this.selectedItem.roles = [];
      }
      // this.selectedRoles = this.selectedItem.roles;
      this.modalEditOpened = true
    },
    cleanItem() {
      for (let key in this.selectedItem) {
        if (typeof this.selectedItem[key] == 'string') {
          this.selectedItem[key] = null
        } else if (typeof this.selectedItem[key] == 'array') {
          this.selectedItem[key] = []
        } else {
          this.selectedItem[key] = null
        }
      }
    },
    showModalChangePassword() {
      this.showChangePassword = !this.showChangePassword
      this.insertPass1 = ''
      this.insertPass2 = ''
    },
    changePass(isSaved) {
      if (this.validPass || !isSaved) {
        this.showChangePassword = !this.showChangePassword
      }
      if (!this.validPass || !isSaved) {
        this.insertPass1 = ''
        this.insertPass2 = ''
      }
      if (!this.validPass && isSaved)
        alert(this.messPass)
    }
  },
  computed: {
    validPassword() {
      this.validPass = true;
      if (this.insertPass1.length === 0 && this.insertPass2.length === 0) {
        this.messPass = 'пароль пустой';
        this.validPass = false;
        return false;
      } else {
        this.messPass = 'пароли не совпадают';
        this.validPass = this.insertPass1 === this.insertPass2;
        return this.insertPass1 === this.insertPass2
      }
    }
  }
})
